import { parseSiteDateFormat, parseSiteDateTimeFormat } from "./time";
import * as _ from "lodash-es";

export const formatSiteDate = (value) => value && parseSiteDateFormat(value);
export const formatSiteDateTime = (value) => value && parseSiteDateTimeFormat(value);

export const withArticle = (value) => {
  const vowel = ["a", "e", "i", "o", "u"];
  if (!value) {
    return value;
  }
  const article = vowel.includes(value.toLowerCase()[0]) ? "an" : "a";
  return `${article} ${value}`;
};

export const yesNo = (value, yesLabel = "Yes", noLabel = "No", maybeLabel = "") =>
  _.isNil(value) ? maybeLabel : value ? yesLabel : noLabel;
